import { mockComponent } from 'bloko/common/setupMockComponents';

const { SelectScale, Option } = jest.requireActual('bloko/blocks/select/index.js');
export { SelectScale, Option };

export default mockComponent('Select', null, {
    // eslint-disable-next-line react/display-name
    innerDependence: ({ children, flexible, light, invalid, scale, source, ...selectProps }) => {
        return <select {...selectProps}>{children}</select>;
    },
});
